import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource/inter'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './security/authConfig'
import { ThemeProvider } from '@mui/material'
import { getDefaultTheme } from './themes'
import { BacklogProvider } from './components/backlog/BacklogContext'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ProjectFeaturesProvider } from './components/project/contexts/ProjectFeaturesContext'
import { AuthProvider } from './security/AuthContext'
import { AttachmentUploadProvider } from './components/project/upload/AttachmentUploadContext'
import { ConnectionProvider } from './components/navigation/ConnectionContext'
import { PermissionProvider } from './security/PermissionContext'
function registerServiceWorker() {
	const isDev = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
	if (isDev) return

	if (!('serviceWorker' in navigator)) return

	let refreshing = false
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (refreshing) return
		refreshing = true
		window.location.reload()
	})
	window.addEventListener('load', async () => {
		const registration = await navigator.serviceWorker.getRegistration('/sw.js')
		if (!registration) {
			navigator.serviceWorker.register('/sw.js')
		}

		// Helper: check if an update is already waiting
		const checkForPendingUpdate = async () => {
			const reg = await navigator.serviceWorker.getRegistration('/sw.js')
			if (reg?.waiting) {
				const ok = window.confirm('A new version is available. Update now?')
				if (ok) {
					reg?.waiting?.postMessage({ type: 'SKIP_WAITING' })
				}
			}
		}

		// Initial check (covers ignored alert + cold app open)
		await checkForPendingUpdate()

		// Detect newly installed updates
		registration?.addEventListener('updatefound', () => {
			const newWorker = registration?.installing
			if (!newWorker) return

			newWorker.addEventListener('statechange', async () => {
				if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
					await checkForPendingUpdate()
				}
			})
		})

		// Tablet-friendly: check again when app resumes
		document.addEventListener('visibilitychange', async () => {
			if (document.visibilityState !== 'visible') return

			try {
				await registration?.update() // ask browser to look for new SW
				await checkForPendingUpdate() // catch "waiting" SW
			} catch {
				// offline / ignored
			}
		})
	})
}
const msalInstance = new PublicClientApplication(msalConfig())
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
// <React.StrictMode>
// was removed because cause Mount/Unmount/Mount on initial load of components
// meaning two fires ALWAYS of useEffect causing double data loads
root.render(
	<MsalProvider instance={msalInstance}>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<ThemeProvider theme={getDefaultTheme()}>
				<CssBaseline />
				<BrowserRouter>
					<AuthProvider>
						<PermissionProvider>
							<ConnectionProvider>
								<ProjectFeaturesProvider>
									<BacklogProvider>
										<AttachmentUploadProvider>
											<App />
										</AttachmentUploadProvider>
									</BacklogProvider>
								</ProjectFeaturesProvider>
							</ConnectionProvider>
						</PermissionProvider>
					</AuthProvider>
				</BrowserRouter>
			</ThemeProvider>
		</LocalizationProvider>
	</MsalProvider>,
)
registerServiceWorker()
reportWebVitals()
